export default "__VITE_ASSET__B58DH7m9__"